import { Typography, Divider, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import BackButton from "../components/Buttons/BackButton";
import FrontOfficeFormSteps from "../components/FormContainers/frontOffice/FrontOfficeFormSteps";
import Theme from "../Themes/main.theme";

const FrontOfficeForm = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <>
      <Box mt={2} mb={2}>
        <BackButton onClick={() => navigate('/admin/units/dashboard')} />
      </Box>
      <Typography variant='h2' sx={{ my: 2 }}
        color={Theme?.labelColor?.main}>
        {t('Δημιουργία Οργανικής Μονάδας ΕΚΟΜΕ')}
      </Typography>
      <Divider sx={{ mb: 5, border: 1, color: Theme?.dividerColor?.main }} />
      <FrontOfficeFormSteps />
    </>
  );
};

export default FrontOfficeForm;
